<template>
  <v-card class="mx-auto" max-width="900">
    <div class="pa-3 d-flex align-center">
      <h2>{{ title }}</h2>

      <v-spacer />
      <v-btn color="primary" icon @click="close">
        <v-icon large color="primary">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-account-outline</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Informações do Revendedor:</span>

      <v-row class="pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="6" md="6" lg="4">
          <p class="label-details">Razão Social:</p>
          <span class="details-text">{{ this.currentResale.name }}</span>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Nome:</p>
            <span class="details-text">{{ this.currentResale.nameFantasy }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">E-mail:</p>
            <span class="details-text">{{ this.currentResale.email }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">CNPJ/CPF:</p>
            <span class="details-text">{{ this.currentResale.cnpj }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Inscr. Estadual:</p>
            <span class="details-text">{{ this.currentResale.inscrEstadual }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Contato:</p>
            <span class="details-text">{{ this.currentResale.phoneNumber }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Data de entrada:</p>
            <span class="details-text">{{ this.currentResale.created_at }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Categoria:</p>
            <span class="details-text">{{ this.currentResale.resaleCategory }}</span>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-google-maps</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Endereço:</span>

      <v-row class="pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">CEP:</p>
            <span class="details-text">{{ this.currentResale.postalCode }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">Logradouro:</p>
            <span class="details-text">{{ this.currentResale.addressName }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">Número:</p>
            <span class="details-text">{{ this.currentResale.addressNumber }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">Bairro:</p>
            <span class="details-text">{{ this.currentResale.neighborhood }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">Estado:</p>
            <span class="details-text">{{ this.currentResale.state }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">Cidade:</p>
            <span class="details-text">{{ this.currentResale.city }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div>
            <p class="label-details">Referência:</p>
            <span class="details-text">{{ this.currentResale.addressComplement }}</span>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-comment-eye-outline</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Observações:</span>

      <v-row class="pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-textarea
            auto-grow
            disabled
            solo
            name="input-7-1"
            :value="this.currentResale.textObservation"
            outlined
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-account-cog-outline</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Administrativo:</span>

      <v-row class="pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="6" md="6" lg="6">
          <div>
            <p class="label-details">
              Status do Revendedor:
              {{ this.currentResale.status == "1" ? "Ativa" : "Inativa" }}
            </p>

            <v-select
              class="ma-0 pa-0"
              style="max-width: 160px; align-self: center; font-weight: bold"
              dense
              hide-details
              outlined
              :items="status"
              item-text="label"
              item-value="value"
              v-model="currentResale.status"
              required
            >
            </v-select>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <div>
            <p class="label-details">Tipo do Revendedor:</p>
            <v-autocomplete
              outlined
              v-model="currentResale.resaleCategory"
              :items="resalesCategory"
              required
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <div>
            <p class="label-details">Texto de Observação:</p>
            <v-textarea
              auto-grow
              solo
              name="input-7-1"
              :value="this.currentResale.textObservation"
              outlined
            ></v-textarea>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn
            large
            color="#2D3038"
            class="white--text"
            @click="close"
            :loading="loading"
          >
            <span>RECUSAR</span>
          </v-btn>

          <v-btn
            elevation="4"
            large
            color="normalred"
            class="white--text"
            @click="editStatus(currentResale), close()"
            :loading="loading"
          >
            <span>APROVAR</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
@media (max-width: 600px) {
  .select-type {
    width: 90% !important;
  }
}

.form {
  display: flex;
  justify-content: center;
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}

.label-details {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  margin: 0;
}

.details-text {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-size: 16px;
  line-height: 25px;
}

.titulo-detail {
  color: black;
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 40px;
  font-weight: bold;
}

/* .select{
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 10px;
} */
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";

export default {
  props: {
    title: String,
    resale: Object,
  },

  created() {
    if (this.resale) {
      this.step = 0;
      this.isEditing = true;

      this.currentResale = {
        id: this.resale.id,
        name: this.resale.name,
        nameFantasy: this.resale.nameFantasy,
        inscrEstadual: this.resale.inscrEstadual,
        cnpj: this.resale.cnpj,
        email: this.resale.email,
        created_at: this.resale.created_at,

        postalCode: this.resale.postalCode,
        country: this.resale.country,
        addressNumber: this.resale.addressNumber,
        addressName: this.resale.addressName,
        neighborhood: this.resale.neighborhood,
        addressComplement: this.resale.addressComplement,

        status: this.resale.status,
        state: this.resale.state,
        city: this.resale.city,
        resaleWebSite: this.resale.resaleWebSite,
        phoneNumber: this.resale.phoneNumber,
        phoneNumber2: this.resale.phoneNumber2,
        receiveEmail: this.resale.receiveEmail,
        receiveSms: this.resale.receiveSMS,
        region: this.resale.region,
        rcategory: this.resale.category,
        observations: this.resale.observations,
      };
    }
  },

  data: () => ({
    dialogKey: false,
    loading: false,
    step: 0,
    error: false,
    isEditing: false,
    stores: [],
    resalesCategory: ["Categoria 1", "Categoria 2", "Categoria 3", "Categoria 4"],

    filter: {
      page: 1,
      pageSize: 15,
      DocumentNumber: null,
      Name: "",
      Cnpj: "",
      resalestatus: "",
      status: null,
      updated_at: null,
    },

    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    resalesCategory: ["Categoria 1", "Categoria 2", "Categoria 3", "Categoria 4"],
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },

    async editStatus(currentResale) {
      this.loading = true;

      this.currentResale = currentResale;

      await this.apiService
        .post(`resale/edit`, this.currentResale)
        .then((resp) => {
          this.loading = false;

          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Revendedor editado com sucesso!",
            message: "",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao editar revenda",
            message: erro.body.message,
            trace: null,
          });
        });
    },
  },
};
</script>
